/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { Account } from '@carbon/react/icons';
import { TextInput } from 'carbon-components-react';
import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';

import { useIsNewIA } from '@ibm-watson/shared/modules/ia/hooks/useIsNewIA';
import { FormattedMessageWithLink } from '../../../helpers/linkHelpers';
import { useFormHelpers } from '../../../hooks/useFormHelpers';
import { ChannelContentProps } from '../../../util/types';
import { TabContent } from '../../common/tabbed-header/TabContent';
import { links } from '../links';
import { FIELDS } from '../schema';
import { AdvancedOptions as messages } from './messages';

export const AdvancedOptions = ({ readOnly }: ChannelContentProps) => {
  const formMethods = useFormContext();
  const { registerInputField } = useFormHelpers(formMethods);

  const configuredMessageChangeState = useState<boolean>(false);
  const runtimeMessageChangeState = useState<boolean>(false);
  const transferMessageChangeState = useState<boolean>(false);

  return (
    <TabContent
      ImageComponent={() => <Account size={32} />}
      title={<FormattedMessage {...messages.title} />}>
      <div className="TabContent__body-content">
        <div className="TabContent__subtitle">
          <FormattedMessage {...messages.subtitle} />
        </div>
        <div className="TabContent__field-container">
          <TextInput
            {...registerInputField({
              field: FIELDS.OPTIONS_CONFIGURED_MESSAGE,
              labelText: messages.configuredMessageLabel,
              changeState: configuredMessageChangeState,
              readOnly
            })}
          />
        </div>
        <div className="TabContent__field-container">
          <TextInput
            {...registerInputField({
              field: FIELDS.RUNTIME_ERROR_MESSAGE,
              labelText: messages.runtimeErrorLabel,
              changeState: runtimeMessageChangeState,
              readOnly
            })}
          />
        </div>
        <div className="TabContent__field-container">
          <TextInput
            {...registerInputField({
              field: FIELDS.TRANSFER_ERROR_MESSAGE,
              labelText: messages.transferErrorLabel,
              changeState: transferMessageChangeState,
              readOnly
            })}
            helperText={
              !useIsNewIA() && (
                <div className="WhatsApp__helperText--link">
                  <FormattedMessageWithLink
                    url={links.learnMoreWhatsAppChannelTransferLink}
                    {...messages.transferErrorDescription}
                  />
                </div>
              )
            }
          />
        </div>
      </div>
    </TabContent>
  );
};
